import React from 'react';
import styled from 'styled-components';

import RightArrow from '../../../../../assets/images/chevron-right.png';
import LeftArrow from '../../../../../assets/images/chevron-left.png';

const GalleryArrow = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: blue;
    background-color: var(--luft-secondary);
    box-shadow: 0px 6px 8px var(--b-shadow);
    position: absolute;
    top: 50%;
    transform: translateY(-50%); 
    z-index: 10;
    cursor: pointer;
    ${({ left }) => left && 'left: -60px'};
    ${({ right }) => right && 'right: -60px'};

    &:focus {
      outline: none;
    }
    &:hover {
      background-color: var(--luft-primary);
    }
`;


export const NextArrow = (props) => {
  const { onClick, nextArrowActive } = props;

  return (
    nextArrowActive
    && (
      <GalleryArrow
        onClick={onClick}
        nextArrowActive={nextArrowActive}
        right
      >
        <img alt="" src={RightArrow} />
      </GalleryArrow>
    )
  );
};

export const PrevArrow = (props) => {
  const { onClick, prevArrowActive } = props;

  return (
    prevArrowActive
    && (
      <GalleryArrow
        onClick={onClick}
        prevArrowActive={prevArrowActive}
        left
      >
        <img alt="" src={LeftArrow} />
      </GalleryArrow>
    )
  );
};
